import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
      Restis post la dorso mia <br/>
      Longa kaj laciga voj’. <br/>
      Jen la nesto cikonia <br/>
      Super mia dom’ ĉe l’ roj’.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Kun kia korsopiro mi <br/>
        Aspiris al la hejmo ĉi, <br/>
        Sed tamen estis tiu voj’ <br/>
        Por ni senlima ĝoj’!
      </p>

      <p class="poem-block mb-3">
      Marŝis ni dum multaj tagoj <br/>
      Laŭ la pintoj de l’ montar’. <br/>
      Apud diafanaj lagoj <br/>
      Tendoj dronis en nubar’.
      </p>

      <p class="poem-block refreno mb-4">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block mb-3">
      Sonis sub altegaj pinoj <br/>
      Kantoj pri malĝoj’ kaj am’. <br/>
      Tristis ni pri amikinoj, <br/>
      Flamis lignofajra flam’.
      </p>

      <p class="poem-block refreno mb-4">
        <span class="italic bold">Rf.</span>
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Turista kanto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: `
      Komponisto kaj aŭtoro de la vortoj nekonata <br/>
      ${translator.esp}
    `
  }
}

export default item;